import { SummaryList } from 'nhsuk-react-components';
import type { IterationRule, RuleType } from 'schemas/IterationRule.schema';
import { RoutingPlans } from 'schemas/RoutingPlan.schema';
import RulesHeader from './RulesHeader';
import TeamDefaultRules from './TeamDefaultRules';
import RuleRow from './RuleRow';

interface RuleSectionProps {
  ruleType: RuleType;
  ruleLabel: string;
  rules: IterationRule[];
  defaultRules: IterationRule[];
  iterationId: string;
  canUpdate: boolean;
  canCreateCustomRules: () => boolean;
  handleRulesSave: (
    rules: IterationRule[],
    ruleType: RuleType
  ) => void;
  teamRoutingPlans?: RoutingPlans;
}

export function RuleSection({
  ruleType,
  ruleLabel,
  rules,
  defaultRules,
  iterationId,
  canUpdate,
  canCreateCustomRules,
  handleRulesSave,
  teamRoutingPlans,
}: RuleSectionProps) {
  return (
    <SummaryList className="summary-table" aria-label={`${ruleLabel}s`}>

      {(defaultRules.length > 0 || rules.length > 0) && (
        <RulesHeader />
      )}

      <TeamDefaultRules rules={defaultRules} />

      <RuleRow
        ruleType={ruleType}
        ruleLabel={ruleLabel}
        rules={rules}
        iterationId={iterationId}
        canUpdate={canUpdate}
        canCreateCustomRules={canCreateCustomRules()}
        handleRulesSave={handleRulesSave}
        offSet={defaultRules.length}
        teamRoutingPlans={teamRoutingPlans}
      />

    </SummaryList>
  );
}

export default RuleSection;
